import { Input } from "@/components/ui/input";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { STATUS_LABEL, TRANCHES, HIRING_LABEL } from "./meta";

const sel = "bg-surface-2 border border-border rounded-md text-xs text-fg px-2 py-1.5 focus:outline-none focus:border-accent/50";

const Sel = ({ k, value, onChange, children, label }) => (
  <label className="flex flex-col gap-1">
    <span className="text-[10px] uppercase tracking-wider text-muted">{label}</span>
    <select className={sel} value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`lead-filter-${k}`}>
      {children}
    </select>
  </label>
);

const Num = ({ k, value, onChange, label, placeholder }) => (
  <label className="flex flex-col gap-1">
    <span className="text-[10px] uppercase tracking-wider text-muted">{label}</span>
    <input type="number" min="0" className={`${sel} w-24`} value={value[k] || ""} placeholder={placeholder}
      onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`lead-filter-${k}`} />
  </label>
);

export default function LeadFilters({ value, onChange, meta, lists, owners }) {
  const reset = () => onChange({});
  return (
    <div className="surface rounded-lg p-4 space-y-3" data-testid="lead-filters">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted" />
          <Input className="bg-surface-2 border-border pl-9" placeholder="Rechercher une entreprise ou un SIREN…" value={value.q || ""}
            onChange={(e) => onChange({ ...value, q: e.target.value })} data-testid="lead-search-input" />
        </div>
        <button onClick={reset} className="text-xs text-muted hover:text-fg flex items-center gap-1 px-3" data-testid="lead-filters-reset"><X size={12} /> Réinitialiser</button>
      </div>
      <div className="flex flex-wrap gap-3 items-end">
        <Sel k="category" value={value} onChange={onChange} label="Catégorie">
          <option value="">Toutes</option><option value="A">A — Procédure collective en cours</option><option value="B">B — Recrutement observé faible</option>
        </Sel>
        <Sel k="region" value={value} onChange={onChange} label="Région">
          <option value="">Toutes</option>{Object.entries(meta.regions || {}).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </Sel>
        <Num k="departement" value={value} onChange={onChange} label="Département" placeholder="ex. 59" />
        <Sel k="tranche" value={value} onChange={onChange} label="Effectif">
          <option value="">Tous</option>{Object.entries(TRANCHES).map(([k, v]) => <option key={k} value={k}>{v} sal.</option>)}
        </Sel>
        <Sel k="naf" value={value} onChange={onChange} label="Code NAF">
          <option value="">Tous</option>{Object.entries(meta.nafs || {}).map(([k, v]) => <option key={k} value={k}>{k} — {v}</option>)}
        </Sel>
        <Sel k="procedure" value={value} onChange={onChange} label="Procédure">
          <option value="">Toutes</option><option value="rj">Redressement judiciaire</option><option value="sauvegarde">Sauvegarde</option>
          <option value="plan_redressement,plan_sauvegarde">Plan en cours</option><option value="liquidation">Liquidation</option>
          <option value="other,resolution_plan,cloture">Autre</option><option value="none">Aucune procédure publique connue</option>
        </Sel>
        <Num k="judgment_since_days" value={value} onChange={onChange} label="Jugement < (jours)" placeholder="90" />
        <Sel k="hiring_level" value={value} onChange={onChange} label="Recrutement">
          <option value="">Tous</option>{Object.entries(HIRING_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </Sel>
        <Num k="offers_90d_max" value={value} onChange={onChange} label="Offres 90 j ≤" />
        <Num k="min_score" value={value} onChange={onChange} label="Score min." placeholder="60" />
        <Sel k="etat" value={value} onChange={onChange} label="État"><option value="">Tous</option><option value="A">Active</option><option value="C">Fermée</option></Sel>
        <Sel k="status" value={value} onChange={onChange} label="Statut">
          <option value="">Tous</option>{Object.entries(STATUS_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </Sel>
        <Sel k="has_website" value={value} onChange={onChange} label="Site web"><option value="">Indifférent</option><option value="true">Oui</option><option value="false">Non</option></Sel>
        <Sel k="has_verified_contact" value={value} onChange={onChange} label="Contact vérifié"><option value="">Indifférent</option><option value="true">Oui</option><option value="false">Non</option></Sel>
        <Num k="updated_since_days" value={value} onChange={onChange} label="MAJ < (jours)" />
        <Sel k="list" value={value} onChange={onChange} label="Liste"><option value="">Toutes</option>{lists.map((l) => <option key={l} value={l}>{l}</option>)}</Sel>
        <Sel k="owner" value={value} onChange={onChange} label="Commercial"><option value="">Tous</option>{owners.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}</Sel>
        <Sel k="priority" value={value} onChange={onChange} label="Prioritaire"><option value="">Indifférent</option><option value="true">Oui</option></Sel>
      </div>
    </div>
  );
}
